import dayjs from 'dayjs';
import moment from 'moment';
import { EQUIPMENT_OPTION_SORT } from '../../utils/constants';
import {
  DEFAULT_PAGINATION_LIMIT,
  DEFAULT_PAGINATION_PAGE,
} from '../logs/contand';
import { getNow } from '../../utils/fixedNow';
const DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.000Z';
export function createDefaultEventHistoryState(calendar){
  const now = getNow();
  return{
    events: [],
    equipmentId: 'INVERTER',
    info: {
      equipmentTitle: '',
      type: 'INVERTER',
      sort: 'DESC',
      limit: DEFAULT_PAGINATION_LIMIT,
      page: DEFAULT_PAGINATION_PAGE,
    },
    dateWeek: [
      calendar ? dayjs(now).calendar('jalali') : dayjs(now),
      calendar ? dayjs(now).calendar('jalali') : dayjs(now),
    ],
    dateValue: [
      calendar
        ? moment(now.toISOString()).locale('fa')
        : moment(now.toISOString()),
      calendar
        ? moment(now.toISOString()).locale('fa')
        : moment(now.toISOString()),
    ],
    startDate: calendar
      ? moment(now.toISOString()).locale('fa').startOf('day').format(DATE_FORMAT)
      : moment(now.toISOString()).startOf('day').format(DATE_FORMAT),
      endDate: calendar
      ? moment(now.toISOString()).locale('fa').endOf('day').format(DATE_FORMAT)
      : moment(now.toISOString()).endOf('day').format(DATE_FORMAT),
    sort: EQUIPMENT_OPTION_SORT.value,
    loading: false,
    submit: false,
  }
}

export const SORT_OPTIONS = [
  { label: 'DESC', value: 'DESC' },
  { label: 'ASC', value: 'ASC' },
];
